import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_tablet-layout/branch/$id/')({
    component: RouteComponent,
})

function RouteComponent() {
    const { id } = Route.useParams()

    return <Navigate params={{ id }} to='/branch/$id/create/service' />
}
